import { EcommerceAPI } from "../Client";

const webhookUrl = (tenant) => `/webhook/instagram/${encodeURIComponent(tenant)}`;

// Meta webhook verification returns the challenge as plain text.
export const verifyInstagramWebhookApi = (tenant, { mode, verifyToken, challenge }) =>
  EcommerceAPI.get(webhookUrl(tenant), {
    params: { "hub.mode": mode, "hub.verify_token": verifyToken, "hub.challenge": challenge },
    responseType: "text",
  });

// Pass the original serialized JSON body and its signature unchanged.
export const receiveInstagramWebhookApi = (tenant, body, signature) =>
  EcommerceAPI.post(webhookUrl(tenant), body, {
    headers: {
      "Content-Type": "application/json",
      ...(signature ? { "X-Hub-Signature-256": signature } : {}),
    },
    transformRequest: [(data) => data],
    responseType: "text",
  });

export const getInstagramPostsApi = ({ limit = 20, after } = {}) =>
  EcommerceAPI.get("/admin/social/instagram/posts", {
    params: { limit, ...(after ? { after } : {}) },
  });
